import { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { createPortal } from 'react-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PostsOficiais from '@/components/feature/PostsOficiais';

/* Fotos reais de eventos atendidos pela STIB (acervo do Daniel).
   Formato: [arquivo-sem-sufixo, categoria, largura, altura, texto alternativo].
   Fotos tiradas de quadros dos reels da propria STIB (@stibpalestrasilenciosa) e do acervo enviado por Daniel.
   Categoria = evento. Para incluir foto: enviar -g.webp e -f.webp para public/img/stib/ e acrescentar linha aqui. */
const FOTOS: [string, string, number, number, string][] = [
  ['evento-soea-mesa-de-som-transmissao', 'soea', 720, 512, 'Mesa de som e transmissão operada pela equipe STIB na 81ª SOEA'],
  ['evento-soea-tecnicos-controle-audio', 'soea', 720, 512, 'Técnicos da STIB no controle do áudio de auditório na 81ª SOEA'],
  ['evento-soea-plateia-auditorio-fones', 'soea', 720, 512, 'Plateia com fones de ouvido sem fio em auditório da 81ª SOEA'],
  ['evento-soea-distribuicao-fones', 'soea', 720, 512, 'Distribuição de fones sem fio para a plateia na 81ª SOEA'],
  ['evento-soea-auditorio-cheio-2000-fones', 'soea', 720, 512, 'Auditório cheio com fones sem fio em uso na 81ª SOEA'],
  ['evento-soea-arquibancada-palestra-fone', 'soea', 720, 512, 'Público acompanhando palestra pelo fone na arquibancada da 81ª SOEA'],
  ['evento-soea-traducao-simultanea-plateia', 'soea', 720, 512, 'Tradução simultânea chegando ao fone da plateia na 81ª SOEA'],
  ['evento-soea-palco-cabine-interpretes', 'soea', 720, 512, 'Palco com cabine de intérpretes e fones montados pela STIB na 81ª SOEA'],
  ['evento-soea-arena-inovacao-plateia', 'soea', 720, 512, 'Arena Inovação da 81ª SOEA com plateia em palestra silenciosa'],
  ['evento-soea-palestras-simultaneas', 'soea', 720, 512, 'Palestras simultâneas, cada plateia no seu canal, na 81ª SOEA'],
  ['evento-soea-arena-conexoes-plateia', 'soea', 720, 512, 'Arena Conexões da 81ª SOEA: plateia ouvindo só a sua palestra'],
  ['evento-soea-arena-contecc', 'soea', 720, 512, 'Arena Contecc da 81ª SOEA com fones de ouvido sem fio'],
  ['evento-soea-sala-sem-vazamento-som', 'soea', 720, 512, 'Sala da 81ª SOEA com plateia no fone, sem vazamento de som'],
  ['evento-soea-stand-crea-palestra', 'soea', 720, 512, 'Stand Crea na 81ª SOEA com palestra no fone'],
  ['evento-soea-stand-crea-apresentacao', 'soea', 720, 512, 'Apresentação no Stand Crea na 81ª SOEA com fones sem fio'],
  ['evento-pediatria-estande-apresentacao', 'pediatria', 720, 512, 'Público no estande ouvindo apresentação pelo fone no Congresso Brasileiro de Pediatria'],
  ['evento-pediatria-ativacao-marca-fones-led', 'pediatria', 720, 512, 'Ativação de marca com fones LED no Congresso Brasileiro de Pediatria'],
  ['evento-pediatria-estande-lotado', 'pediatria', 720, 512, 'Visitantes com fones sem fio em estande lotado no Congresso Brasileiro de Pediatria'],
  ['evento-led-plateia-fones', 'palestras', 720, 512, 'Plateia com fones LED em palestra silenciosa'],
  ['evento-led-salao-unifatecie', 'palestras', 720, 512, 'Salão com fones sem fio em palestra silenciosa da UNIFATECIE'],
  ['evento-led-fone-em-cada-cadeira', 'palestras', 720, 512, 'Um fone LED em cada cadeira antes da abertura do evento'],
  ['evento-led-salao-pronto-testado', 'palestras', 720, 512, 'Salão pronto e testado com fones sem fio'],
  ['evento-led-participante-ouvindo', 'palestras', 720, 512, 'Participante ouvindo palestra com fone LED'],
  ['evento-conahp-transamerica-expo', 'palestras', 720, 512, 'CONAHP 2026 no Transamerica Expo Center preparado para palestra silenciosa'],
  ['evento-enavseg-plateia-fones', 'enavseg', 480, 600, 'Plateia com fones sem fio no ENAVSEG 2026'],
  ['evento-enavseg-palestras-simultaneas', 'enavseg', 480, 600, 'Palestras simultâneas com fones sem fio no ENAVSEG 2026'],
  ['evento-enavseg-auditorio', 'enavseg', 480, 600, 'Auditório do ENAVSEG 2026 com fones sem fio'],
  ['evento-enavseg-entrega-fones', 'enavseg', 720, 900, 'Entrega de fones sem fio no ENAVSEG 2026'],
  ['evento-bem-estar-relaxamento-guiado', 'bem-estar', 720, 900, 'Relaxamento guiado com fones sem fio'],
  ['evento-bem-estar-aula-yoga', 'bem-estar', 720, 900, 'Aula de yoga com fones sem fio'],
  ['evento-bem-estar-aula-silenciosa', 'bem-estar', 720, 900, 'Participante em aula silenciosa com fone sem fio'],
  ['evento-bem-estar-experiencia-imersiva', 'bem-estar', 576, 720, 'Participante com fone sem fio em experiência imersiva'],
  ['evento-ibirapuera-meditacao-guiada', 'bem-estar', 576, 720, 'Meditação guiada com fones sem fio no Parque Ibirapuera'],
  ['evento-ibirapuera-salao-fones', 'bem-estar', 576, 720, 'Salão com participantes usando fones sem fio no Parque Ibirapuera'],
  ['evento-ibirapuera-experiencia-cha', 'bem-estar', 576, 720, 'Experiência com fones sem fio no Parque Ibirapuera'],
  ['evento-brasilia-parque-da-cidade-aula', 'bem-estar', 720, 900, 'Aula silenciosa no Parque da Cidade, Brasília'],
  ['evento-soea-auditorio-caueira', 'soea', 720, 512, 'Auditório Caueira da 81ª SOEA com plateia no fone'],
  ['evento-pediatria-apresentacao-ao-vivo', 'pediatria', 720, 512, 'Apresentação ao vivo no estande com fones sem fio no Congresso Brasileiro de Pediatria'],
  ['evento-enavseg-publico-palestra', 'enavseg', 480, 600, 'Público do ENAVSEG 2026 acompanhando palestra pelo fone'],
  ['evento-ibirapuera-instrutora-participantes', 'bem-estar', 576, 720, 'Instrutora conduzindo experiência com fones sem fio no Parque Ibirapuera'],
  ['evento-plateia-fones-sem-fio-congresso', 'enavseg', 825, 1100, 'Participantes de congresso usando fones sem fio na plateia'],
  ['evento-plateia-fones-sem-fio-palco-congresso', 'enavseg', 1100, 825, 'Plateia com fones sem fio acompanhando palco de congresso'],
  ['evento-palestra-silenciosa-plateia-feira-evento', 'palestras', 1100, 825, 'Plateia de feira com fones sem fio luminosos em palestra silenciosa'],
];

const CATEGORIAS: { id: string; label: string }[] = [
  { id: 'todas', label: 'Todas' },
  { id: 'soea', label: '81ª SOEA (Aracaju/SE)' },
  { id: 'pediatria', label: 'Congresso Brasileiro de Pediatria' },
  { id: 'enavseg', label: 'ENAVSEG 2026 (Brasília/DF)' },
  { id: 'palestras', label: 'Palestras e congressos' },
  { id: 'bem-estar', label: 'Aulas e bem-estar' },
];

const BASE = '/img/stib/';

export default function EventosPage() {
  const [categoria, setCategoria] = useState('todas');
  const [aberta, setAberta] = useState<number | null>(null);
  const fecharRef = useRef<HTMLButtonElement>(null);
  const origemRef = useRef<HTMLElement | null>(null);

  const categoriasVisiveis = CATEGORIAS.filter((c) => c.id === 'todas' || FOTOS.some((f) => f[1] === c.id));
  const lista = FOTOS.filter((f) => categoria === 'todas' || f[1] === categoria);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://stibpalestrasilenciosasp.com.br';
    document.title = 'Fotos de Eventos Reais | STIB Palestra Silenciosa';
    document.querySelector('meta[name="description"]')?.setAttribute('content', `Fotos reais de eventos atendidos pela STIB: plateias com fones sem fio e palestra silenciosa em congressos e feiras.`);
    document.querySelector('meta[name="last-modified"]')?.setAttribute('content', new Date().toISOString().split('T')[0]);

    const schemas = [
      {
        id: 'eventos-gallery-schema',
        schema: {
          '@context': 'https://schema.org',
          '@type': 'ImageGallery',
          name: 'Fotos de eventos reais - STIB Palestra Silenciosa',
          url: `${siteUrl}/eventos`,
          inLanguage: 'pt-BR',
          provider: { '@type': 'LocalBusiness', name: 'STIB - Palestra Silenciosa São Paulo', url: siteUrl },
          image: FOTOS.map((f) => ({
            '@type': 'ImageObject',
            contentUrl: `${siteUrl}${BASE}${f[0]}-f.webp`,
            thumbnailUrl: `${siteUrl}${BASE}${f[0]}-g.webp`,
            caption: f[4],
            width: 1800,
          })),
        },
      },
      {
        id: 'eventos-breadcrumb-schema',
        schema: {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Eventos', item: `${siteUrl}/eventos` },
          ],
        },
      },
    ];
    schemas.forEach(({ id, schema }) => {
      const el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = id;
      el.text = JSON.stringify(schema);
      document.head.appendChild(el);
    });
    return () => schemas.forEach(({ id }) => document.getElementById(id)?.remove());
  }, []);

  const abrir = (i: number) => {
    origemRef.current = document.activeElement as HTMLElement | null;
    setAberta(i);
  };
  const fechar = useCallback(() => {
    setAberta(null);
    origemRef.current?.focus?.();
  }, []);
  const mover = useCallback(
    (d: number) => setAberta((i) => (i === null ? i : (i + d + lista.length) % lista.length)),
    [lista.length],
  );

  useEffect(() => {
    if (aberta === null) return;
    const antes = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    fecharRef.current?.focus();
    const tecla = (e: KeyboardEvent) => {
      if (e.key === 'Escape') fechar();
      else if (e.key === 'ArrowRight') mover(1);
      else if (e.key === 'ArrowLeft') mover(-1);
    };
    window.addEventListener('keydown', tecla);
    return () => {
      window.removeEventListener('keydown', tecla);
      document.body.style.overflow = antes;
    };
  }, [aberta, fechar, mover]);

  const atual = aberta !== null ? lista[aberta] : null;

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative h-[420px] flex items-center justify-center overflow-hidden mt-[72px]">
        <div className="absolute inset-0">
          <img
            src={`${BASE}evento-plateia-fones-sem-fio-palco-congresso-f.webp`}
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-secondary/70 via-secondary/55 to-secondary/75"></div>
        </div>
        <div className="absolute top-6 left-0 right-0 z-20">
          <div className="max-w-7xl mx-auto px-6">
            <Breadcrumb variant="light" items={[{ label: 'Home', to: '/' }, { label: 'Eventos' }]} />
          </div>
        </div>
        <div className="relative z-10 text-center px-6 w-full max-w-4xl mx-auto">
          <p className="font-body text-primary font-semibold text-sm uppercase tracking-widest mb-3">Registros reais</p>
          <h1 className="font-heading font-bold text-4xl md:text-6xl text-white mb-5">FOTOS DE EVENTOS REAIS</h1>
          <p className="font-body text-lg text-white/85 max-w-2xl mx-auto">
            Plateias com fones sem fio em congressos e feiras atendidos pela equipe da STIB.
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className={`flex flex-wrap items-center justify-center gap-3 mb-10 ${categoriasVisiveis.length <= 2 ? 'hidden' : ''}`} role="group" aria-label="Filtrar fotos por categoria">
            {categoriasVisiveis.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => setCategoria(c.id)}
                aria-pressed={categoria === c.id}
                className={`font-body text-sm font-semibold px-5 py-2.5 rounded-full border transition-colors cursor-pointer ${
                  categoria === c.id
                    ? 'bg-secondary text-white border-secondary'
                    : 'bg-white text-secondary border-gray-200 hover:border-primary hover:text-primary'
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>

          <ul className="columns-1 sm:columns-2 lg:columns-3 gap-6 max-w-6xl mx-auto list-none p-0 m-0">
            {lista.map((f, i) => (
              <li key={f[0]} className="mb-6 break-inside-avoid">
                <button
                  type="button"
                  onClick={() => abrir(i)}
                  aria-label={`Ampliar foto: ${f[4]}`}
                  className="group block w-full overflow-hidden rounded-2xl bg-gray-200 cursor-pointer"
                >
                  <img
                    src={`${BASE}${f[0]}-g.webp`}
                    alt={f[4]}
                    width={f[2]}
                    height={f[3]}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-auto block transition-transform duration-500 group-hover:scale-105"
                  />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-secondary mb-4">Quer um evento assim?</h2>
          <p className="font-body text-gray-600 leading-relaxed mb-8">
            Conte o formato do seu evento e receba uma proposta com fones sem fio, palestra silenciosa ou tradução simultânea.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link to="/orcamento" className="font-body font-semibold bg-primary text-secondary px-8 py-3.5 rounded-full hover:opacity-90 transition-opacity">
              Solicitar orçamento
            </Link>
            <Link to="/portfolio" className="font-body font-semibold border border-secondary text-secondary px-8 py-3.5 rounded-full hover:bg-secondary hover:text-white transition-colors">
              Ver clientes atendidos
            </Link>
          </div>
        </div>
      </section>

      {atual && createPortal(
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Foto ampliada"
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={fechar}
        >
          <button
            ref={fecharRef}
            type="button"
            onClick={fechar}
            aria-label="Fechar foto"
            className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/15 text-white text-2xl leading-none hover:bg-white/30 transition-colors cursor-pointer"
          >
            ×
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); mover(-1); }}
            aria-label="Foto anterior"
            className="absolute left-3 md:left-6 w-11 h-11 rounded-full bg-white/15 text-white text-2xl hover:bg-white/30 transition-colors cursor-pointer"
          >
            ‹
          </button>
          <figure className="max-w-5xl max-h-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={`${BASE}${atual[0]}-f.webp`}
              alt={atual[4]}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <figcaption className="font-body text-sm text-white/80 mt-3 text-center">{atual[4]}</figcaption>
          </figure>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); mover(1); }}
            aria-label="Próxima foto"
            className="absolute right-3 md:right-6 w-11 h-11 rounded-full bg-white/15 text-white text-2xl hover:bg-white/30 transition-colors cursor-pointer"
          >
            ›
          </button>
        </div>,
        document.body,
      )}

      <PostsOficiais />
      <Footer />
    </div>
  );
}
